import { MenuItem, Select, styled } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FleetConfigFooter } from "src/components/FleetConfigFooter";
import { usePredefinedFleetConfigUpdateMutation } from "src/hooks";
import type { PredefinedLEZOption } from "src/types";

interface Props {
  options: PredefinedLEZOption[];
  readOnly: boolean;
  defaultValue: string;
  lezId: number | string;
  scenarioId: number | string;
  onClose: () => void;
}
export function PredefinedFleetConfigSelection(props: Props) {
  const { options, readOnly, defaultValue, lezId, scenarioId, onClose } = props;
  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = useState<string>(defaultValue);
  const {
    isLoading,
    mutateAsync: updatePredefinedFleet,
    error,
  } = usePredefinedFleetConfigUpdateMutation(lezId, scenarioId);

  async function handleSave(option: string) {
    await updatePredefinedFleet(option, {
      onSuccess: () => {
        onClose();
      },
    });
  }

  return (
    <>
      <Styles
        disabled={readOnly || isLoading}
        displayEmpty
        placeholder={t("label.selectPredefinedFleet")}
        onChange={(e) => setSelectedOption(e.target.value as string)}
        value={selectedOption}
      >
        <MenuItem disabled value="">
          <em>{t("label.selectPredefinedFleet")}</em>
        </MenuItem>
        {options.map((l) => (
          <MenuItem key={l.nameKey} value={l.nameKey}>
            {l.nameTranslation}
          </MenuItem>
        ))}
      </Styles>
      <FleetConfigFooter
        onClose={onClose}
        onSave={() => handleSave(selectedOption)}
        disabled={readOnly || selectedOption === "" || isLoading}
        isLoading={isLoading}
        errors={error?.response?.data}
      />
    </>
  );
}

const Styles = styled(Select)``;
